import Button from "../Button";

export default function CTA() {
  return (
    <section className="relative overflow-hidden bg-bridge">
      <div className="absolute -right-24 top-[-140px] h-[360px] w-[360px] rounded-full bg-white/20 blur-3xl" />
      <div className="container relative flex flex-col gap-7 py-16 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="eyebrow text-ink/60">Ready when you are</p>
          <h2 className="mt-3 max-w-2xl font-display text-3xl font-extrabold tracking-[-.04em] text-ink sm:text-4xl">
            Bring us the outcome. We will help move the details.
          </h2>
        </div>
        <Button to="/signup" variant="dark">
          Get started
        </Button>
      </div>
    </section>
  );
}
